module.exports = __webpack_public_path__ + "img/3.b9135080.jpg";